/**
 * i18n Konfiguration — Easy Gutachter.
 *
 * Statisches i18next-Setup mit 7 Sprachen:
 *   de (default), en, fr, it, es, nl, pl
 *
 * Übersetzungs-Dateien liegen unter `./locales/{lang}.json`.
 * Persistenz erfolgt via LocalStorage (Browser-Sprache als initialer
 * Fallback, sofern unterstützt — sonst Deutsch).
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import es from "./locales/es.json";
import nl from "./locales/nl.json";
import pl from "./locales/pl.json";
import ar from "./locales/ar.json";
import ru from "./locales/ru.json";
import tr from "./locales/tr.json";
import el from "./locales/el.json";
import sq from "./locales/sq.json";
import ku from "./locales/ku.json";

export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
  { code: "el", label: "Ελληνικά", flag: "🇬🇷" },
  { code: "sq", label: "Shqip", flag: "🇦🇱" },
  { code: "ku", label: "Kurdî", flag: "☀️" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
];

// Sprachen, die von rechts nach links geschrieben werden.
export const RTL_LANGUAGES = new Set(["ar"]);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
      it: { translation: it },
      es: { translation: es },
      nl: { translation: nl },
      pl: { translation: pl },
      tr: { translation: tr },
      el: { translation: el },
      sq: { translation: sq },
      ku: { translation: ku },
      ru: { translation: ru },
      ar: { translation: ar },
    },
    fallbackLng: "de",
    supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
    interpolation: { escapeValue: false }, // React schützt bereits gegen XSS
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "easygutachter.lang",
      caches: ["localStorage"],
    },
    returnNull: false,
  });

export default i18n;
